import { render } from "./SkeletonNotification.vue?vue&type=template&id=ca38e734"
import script from "./SkeletonNotification.vue?vue&type=script&lang=js"
export * from "./SkeletonNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__